// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.
import _wsShared from '@symbo-ls/workspace-shared'
const shellGetSDK = (...args) => _wsShared.functions.getSDK(...args)

// SDK-only anonymous-demo provisioning for the auto-enter /demo loader
// (pages/demo.js). Calls the public POST /core/demo/enter route through the
// SDK's AuthService.enterDemo, which mints an ANONYMOUS demo access/refresh
// token (no email required) and applies it to localStorage via the
// TokenManager automatically — so the caller only full-reloads afterward for
// the shell to take the authed branch and mount into the personal demo org.
//
// Invoked from the gate page via `el.call('enterDemo')` (no imports between
// project files; the page never closes over getSDK directly). Takes NO
// arguments — the server creates a throwaway `demo-anon-…@demo.symbols.app`
// account. Resolves with the SDK's response data on success; rejects with the
// SDK error on failure (the loader shows a Retry affordance).
export const enterDemo = async () => shellGetSDK().enterDemo()
